export default {
    pageTitle: 'Registration | Test account',
    title: 'Test the Trendmanager free of charge',
    intro1: 'Register for your free trial period and get to know all the functions.',
    intro2: 'The trial period starts immediately after your first login and ends automatically after 72 hours. No payment details required.',
    success: 'Your registration was successful'
}
